import axios from "axios";
import store from "./store";

const http = axios.create({baseURL: process.env.VUE_APP_BASE_URL+process.env.VUE_APP_API_PATH})

http.interceptors.request.use((config) => {

    if(!config.url.includes('event')){
        store.dispatch('loading', true)
    }

    const token = store.getters.token

    if(config && config.headers){
        if(token){
            config.headers.Authorization = `Bearer ${token}`
        }
    }

    return config
},(error) => {
    store.dispatch('loading', false)
    return Promise.reject(error);
})

http.interceptors.response.use((response) => {
    store.dispatch('loading', false)
    return response
}, (error) => {
    store.dispatch('loading', false)
    console.log(error.response)
    /*if(response.status === 401 && !store.getters.loggedOutAlerted){
        store.commit('loggedOutAlerted', true)
        store.dispatch('loggedOutAlert').then((answer) => {
            if(answer){
                store.dispatch('logout').then(() => {
                    router.push({name: 'login'})
                })
            }
        })
    }*/
    return error
})

export default http
